export const buildInsightsSearchPattern = (query: string): string =>
  query
    .split(/\s+/)
    .filter((term) => term.replace(/\*/g, "").length > 0)
    .map((term) => (term.endsWith("*") ? term : `${term}*`))
    .join(" ");
